export const addButtonWrapperStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginBottom: '4px',
};

export const bulkPasteWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
};

export const bulkPasteTextAreaStyles = {
  width: '100%',
  minHeight: '200px',
};

export const bulkPasteButtonsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
};
